import React, { useState } from 'react'
import Register from '../../components/auth/Register'

import { useDispatch, useSelector } from 'react-redux'
import { registerAccount, updateProfile } from '../../actions/accountActions'
import {
    ensureArray,
    errorHandle,
    showMessageSuccess,
} from '../../utils/helper'
import { registerFormValid } from '../../validation'
import { convertErrorYup } from '../../utils/helper'
import { useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import paths from '../../routes/paths'
import useDidMountEffect from '../../hooks/useDidMountEffect'
import apiErrorCodeMap from '../../constants/apiErrorCodeMap'

const defaultForm = {
    // userAddressNote: 'string',
    // userAddressNumber: 'string',
    // userAvatar: 'string',
    // userCity: 'string',
    // userEmail: 'string@gmail.com',
    // userName: 'string',
    // userNamePrefix: 'string',
    // userOfficeName: 'string',
    // userPassword: 'string113',
    // confirmPassword: 'string113',
    // userPhone: 'string',
    // userPostcode: 'string',
    // userStreet: 'string',
    // userUsername: 'string',
}

const RegisterContainer = props => {
    const isUpdate = props.location.pathname === paths.updateProfile

    const { t } = useTranslation()
    const dispatch = useDispatch()
    const history = useHistory()
    const user = useSelector(state => state.AccountReducer.user)

    const [form, setForm] = useState({ ...(isUpdate ? user : defaultForm) })
    const [errors, setErrors] = useState({})

    const handleInputChange = e => {
        const { name, value } = e.target
        setForm(prev => ({ ...prev, [name]: value }))
    }

    const clearErrorField = field =>
        setErrors(prev => ({ ...prev, [field]: '' }))

    const handleRegister = async () => {
        const { confirmPassword, ...rest } = form
        dispatch(
            registerAccount({
                params: { ...rest, fromShopId: 27 },
                onDone: ({ responseData, success }) => {
                    if (success) {
                        // setForm({ ...defaultForm })
                        // show message success
                        showMessageSuccess(t('message.registerSuccess'))
                        history.push(paths.home)
                    } else {
                        if (responseData?.data) {
                            setErrors(
                                ensureArray(responseData?.data).reduce(
                                    (rs, current) => ({
                                        ...rs,
                                        [current.field]: current.message,
                                    }),
                                    {}
                                )
                            )
                        } else {
                            const message = apiErrorCodeMap[responseData.code] || 'apiMessage.registerFailed'
                            errorHandle({ message })
                        }
                    }
                },
            })
        )
    }

    const handleUpdate = async () => {
        const { confirmPassword, ...rest } = form
        dispatch(
            updateProfile({
                params: { ...rest, fromShopId: 27 },
                onDone: ({ responseData, success }) => {
                    if (success) {
                        // show message success
                        showMessageSuccess(t('message.updateUserInfoSuccess'))
                    } else {
                        if (responseData?.data) {
                            setErrors(
                                ensureArray(responseData?.data).reduce(
                                    (rs, current) => ({
                                        ...rs,
                                        [current.field]: current.message,
                                    }),
                                    {}
                                )
                            )
                        } else {
                            errorHandle({
                                message: 'apiMessage.updateProfileFailed',
                            })
                        }
                    }
                },
            })
        )
    }

    const handleSubmit = async e => {
        e && e.preventDefault()

        try {
            await registerFormValid.validate(
                { ...form, isUpdate },
                { abortEarly: false }
            )
            if (isUpdate) {
                await handleUpdate()
            } else {
                await handleRegister()
            }
        } catch (error) {
            if (error?.name === 'ValidationError') {
                setErrors(convertErrorYup(error))
            }
        }
    }

    useDidMountEffect(() => {
        isUpdate &&
            user &&
            setForm(prev => ({
                ...prev,
                ...user,
            }))
    }, [isUpdate, user])

    return (
        <Register
            isUpdate={isUpdate}
            handleSubmit={handleSubmit}
            form={form}
            handleInputChange={handleInputChange}
            clearErrorField={clearErrorField}
            errors={errors}
        />
    )
}

export default RegisterContainer
